export default {
  'exception.back': '返回首页',
  'exception.description.403': '抱歉，你无权访问此页面',
  'exception.description.404': '抱歉，你访问的页面不存在',
  'exception.description.500': '抱歉，服务器出错了',
};
